import React from "react";
import classNames from "classnames";

import "./ErrorMessage.scss";

interface errorMessage {
  children: Element | any,
  className?: string,
  onResetPassword?() : void

}
export const ErrorMessage: React.FunctionComponent<errorMessage> = (props) => {
  return (
    <p
      {...props}
      className={classNames("ErrorMessage", "App_formError", props.className)}
      role="alert"
    >
      {props.children === "wrong_credential" ?  <>
        It looks like you're having trouble logging in. Please try again or <b className="reset-btn" onClick={() => props?.onResetPassword?.()}>reset your password</b>
      </>
      : props.children}
    </p>
  );
}
